import { render, staticRenderFns } from "./cari2duzenle.vue?vue&type=template&id=9e870db6&scoped=true&"
import script from "./cari2duzenle.vue?vue&type=script&lang=js&"
export * from "./cari2duzenle.vue?vue&type=script&lang=js&"
import style0 from "./cari2duzenle.vue?vue&type=style&index=0&id=9e870db6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e870db6",
  null
  
)

export default component.exports